import { automationsRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { DeleteAutomationDocumentJson } from '../types';

export const useDeleteDocument = () =>
  useMutation<unknown, unknown, DeleteAutomationDocumentJson>(
    (deleteAutomationDocument) =>
      automationsRepo.deleteDocument(deleteAutomationDocument),
  );
